/**
 * Ordena objetos por sua propriedade 'position'
 * @param a Primeiro objeto com propriedade position
 * @param b Segundo objeto com propriedade position
 * @returns Valor para ordenação (-1, 0, 1)
 */
export const sortByPosition = (
  a: { position: number | null },
  b: { position: number | null }
): number => {
  if (a.position === null && b.position === null) return 0
  if (a.position === null) return 1
  if (b.position === null) return -1
  return a.position - b.position
}
